import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

interface StarRatingProps {
  value: number;
  onChange?: (value: number) => void;
  max?: number;
  size?: number;
  className?: string;
}

export function StarRating({ value, onChange, max = 5, size = 24, className }: StarRatingProps) {
  const interactive = !!onChange;

  return (
    <div className={cn('inline-flex items-center gap-0.5', className)}>
      {Array.from({ length: max }, (_, i) => {
        const starIndex = i + 1;
        const filled = starIndex <= value;
        return (
          <button
            key={i}
            type="button"
            disabled={!interactive}
            className={cn(
              'transition-colors disabled:cursor-default',
              interactive && 'cursor-pointer hover:scale-110',
            )}
            onClick={() => onChange?.(starIndex)}
            aria-label={`${starIndex} star${starIndex > 1 ? 's' : ''}`}
          >
            <Star
              size={size}
              className={filled ? 'fill-amber-400 text-amber-400' : 'text-neutral-300'}
            />
          </button>
        );
      })}
    </div>
  );
}
